var map = {
	"./components/catalogos/catalogos.module": [
		"./src/app/components/catalogos/catalogos.module.ts",
		"default~components-catalogos-catalogos-module~components-dashboard-dashboard-module",
		"common",
		"components-catalogos-catalogos-module"
	],
	"./components/config/config.module": [
		"./src/app/components/config/config.module.ts",
		"common",
		"components-config-config-module"
	],
	"./components/dashboard/dashboard.module": [
		"./src/app/components/dashboard/dashboard.module.ts",
		"default~components-catalogos-catalogos-module~components-dashboard-dashboard-module",
		"common",
		"components-dashboard-dashboard-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;